export const DESTINATION_LIST_SEARCH_FILTER_KEY = 'term';
